"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const Dialog = require("../shared/Dialog/DialogActions");
const lodash_1 = require("lodash");
const LandingActions_1 = require("./LandingActions");
const LandingStore_1 = require("./LandingStore");
const constants_1 = require("../constants");
const store_1 = require("../store");
function landingReducer(state = constants_1.INITIAL_STATE.landingPage, action) {
    switch (action.type) {
        case constants_1.ACTIONS.Landing.SHOW_MODAL:
            return Object.assign({}, state, {
                modal: action.payload.modal,
                src: action.payload.src
            });
        case constants_1.ACTIONS.Authentication.LOGIN:
            return Object.assign({}, state, {
                loginProgress: constants_1.ProgressState.Loading
            });
        case constants_1.ACTIONS.Authentication.LOGIN_SUCCESS:
            // delay(() => {
            //     store.dispatch(openModal(LandingModal.Closed));
            // }, 500);
            return Object.assign({}, state, {
                loginProgress: constants_1.ProgressState.Success
            });
        case constants_1.ACTIONS.Authentication.LOGIN_FAILED:
            return Object.assign({}, state, {
                loginProgress: constants_1.ProgressState.Failed,
                loginErrors: action.payload
            });
        case constants_1.ACTIONS.Authentication.REGISTER_ORG:
            return Object.assign({}, state, {
                registerProgress: constants_1.ProgressState.Loading
            });
        case constants_1.ACTIONS.Authentication.REGISTER:
            return Object.assign({}, state, {
                registerProgress: constants_1.ProgressState.Loading
            });
        case constants_1.ACTIONS.Authentication.REGISTER_SUCCESS:
            lodash_1.delay(() => {
                store_1.default.dispatch(LandingActions_1.openModal(LandingStore_1.LandingModal.Closed));
                Dialog.showAlertDialog({
                    title: "Congratulations",
                    message: "You have successfully registered. Please check your email to activate your account."
                });
            }, 500);
            return Object.assign({}, state, {
                loginProgress: constants_1.ProgressState.Success
            });
        case constants_1.ACTIONS.Authentication.REGISTER_FAILED:
            return Object.assign({}, state, {
                registerProgress: constants_1.ProgressState.Failed,
                registerErrors: action.payload
            });
        default:
            return state;
    }
}
exports.landingReducer = landingReducer;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/LandingReducer.ts
// module id = 604
// module chunks = 0 1 2